import React, { useContext, useEffect, useRef, useState } from 'react';
import { AlertWrapper, ModalWraper } from '../UI/styledConstants';
import IconClose from '../../assets/images/IconClose';
import { addBeneficiaryRequest, AddBeneficiaryVerifyOtp, getPennyDrop, getSendMoneyBankList } from '../../utils/api';
import { clickOutside, isEmpty, overLayers } from '../../utils/common';
import Loader from '../UI/Loader/Loader';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import {ifsc} from './ifsc';

const initControls = {
	accountNumber: '',
	bankId: '',
	ifsc: '',
	beneName: '',
	beneMobileNumber:""
};

export default function AddBeneficiaryModal({ modalData = null, mobileNumber = '', onCloseModal = () => {}, verifySenderStatus = () => {}, setModal }) {
	const [controls, setControls] = useState({ ...initControls });
	const [pageMsg, setPageMsg] = useState({});
	const [bankList, setBankList] = useState(null);
	const [filterBankList, setFilterBankList] = useState(null);
	const [dropDown, setDropdown] = useState(false);
	const [searchKey, setSearchKey] = useState('');
	const [loding, setLoding] = useState(false);
	const [isVerify, setIsVerify] = useState(false);
	const [beneName, setBeneName] = useState("");
	const [otp,setOtp] = useState("");
	const [data,setData] = useState({})
		const [isVerifyOtp, setIsVerifyOtp] = useState(false)

	const numberReg = /^[0-9]+$/;
	const nameReg = /^[A-Za-z\s]+$/i;
	
	const { setRefresh, refresh ,setAlert} = useContext(GlobleContaxt);

	const changeHandler = (e) => {
		const { name, value } = e.target;

		if (name === 'beneName') {
			if (!nameReg.test(value) && value) {
				return false;
			}
		}
		if ((name === 'accountNumber') || (name === "beneMobileNumber")) {
			if (!numberReg.test(value) && value) {
				return false;
			}
		}

		setControls({ ...controls, [name]: value });
		if (name === 'ifsc') {
			setControls({ ...controls, [name]: value.toUpperCase() });
		}
		if (name == 'bankId') {
			setDropdown(false);
			setSearchKey(e.target?.nextElementSibling?.innerHTML);
		}
	};

	const selectBankWithMifsc = (e,item)=>{
		const { name, value } = e.target;
		setControls({ ...controls, bankId: value });
		setDropdown(false);
		setSearchKey(e.target?.nextElementSibling?.innerHTML);
		for (const entry of ifsc) {
		
			if (entry["name"].toUpperCase() === item.name.toUpperCase()) {
				setControls({ ...controls, bankId: value,ifsc:entry['ifsc'] });
			}
		  }
	}

	const onSubmit = () => {
		if (isEmpty(controls.beneName)) {
			setPageMsg({ type: 'error', text: 'Name are required.' });
			return;
		} else if(isEmpty(controls.beneMobileNumber)){
			setPageMsg({ type: 'error', text: 'Mobile number are required.' });
		}else if (isEmpty(controls.accountNumber)) {
			setPageMsg({ type: 'error', text: 'Account number are required.' });
			return;
		} else if (isEmpty(controls.ifsc)) {
			setPageMsg({ type: 'error', text: 'Ifsc code are required.' });
			return;
		} else if (isEmpty(controls.bankId)) {
			setPageMsg({ type: 'error', text: 'Bank name are required.' });
			return;
		}

		addBeneficiaries();
		
	};

	const addBeneficiaries = () => {
		const params = {
			...controls,
			remitterMobileNumber:mobileNumber,
		};
		setLoding(true);
		addBeneficiaryRequest(params).then((response) => {
			setLoding(false);
			if (response?.success) {
				setBeneName("");
		setIsVerify(false);
				setIsVerifyOtp(true)
				setData(response?.data?.data || {})
				setPageMsg({ type: 'success', text: response?.msg });
			} else {
				
				if (response?.errorCodeList.length > 0) {
					setPageMsg({ type: 'error', text: response?.errorCodeList[0] });
				}else{
					setPageMsg({ type: 'error', text: response?.msg });
				}
			}
		});
	};

	useEffect(() => {
		getSendMoneyBankList().then((res) => {
			if (res?.data) {
				setBankList(res?.data);
			}
		});
	}, []);

	const handleFilter = (event) => {
		if (bankList) {
			const keyword = event.target.value;

			if (!nameReg.test(keyword) && keyword) {
				return false;
			}

			setSearchKey(keyword.toUpperCase());
			const pattern = new RegExp('^' + keyword, 'i');
			const filtered = bankList.filter((item, index) => {
				return pattern.test(item.name);
			});

			if (keyword) {
				setFilterBankList(filtered.slice(0, 6));
			} else {
				setFilterBankList(null);
			}
		}
	};

	
	

	
		const boxRef = useRef(null);
		useEffect(() =>{
			overLayers(true);
			clickOutside(true,boxRef,onCloseModal);
		
			return(() =>{
				overLayers(false)
				clickOutside(false,boxRef,onCloseModal);
			})
		
		},[]);


		const onVefify = () => {
				if (isEmpty(otp)) {
					setPageMsg({ type: 'error', text: 'Please enter otp' });
					return;
				} 
		
				const params = {
					remitterMobileNumber:mobileNumber,
					beneId: data?.beneficiaryId,
					otp: otp,
					referenceKey: data?.referenceKey,
				};
				setLoding(true);
				AddBeneficiaryVerifyOtp(params).then((resp) => {
					setLoding(false);
					if (resp?.success) {
						setModal({ name: '', modalData: null });
					verifySenderStatus(mobileNumber);
						setControls({ ...initControls });
					} else {
						if (resp?.errorCodeList.length > 0) {
							setPageMsg({type: 'error',text:resp?.errorCodeList[0]});
						} else {
							setPageMsg({type: 'error',text:resp?.msg});
							
						}
					}
					
				});
			};


useEffect(() =>{
	if(isEmpty(pageMsg)) return;

    setTimeout(() =>{
        setPageMsg({})
	},5000)



},[pageMsg]);

const verifyAccount = (e) => {
		if (isEmpty(controls.accountNumber)) {
			setPageMsg({ type: 'error', text: 'Account number are required.' });
			return;
		} else if (isEmpty(controls.ifsc)) {
			setPageMsg({ type: 'error', text: 'Ifsc code are required.' });
			return;
		}else if (isEmpty(controls.bankId)) {
			setPageMsg({ type: 'error', text: 'Bank name are required.' });
			return;
		}


		const params = {
			bankAccount: controls.accountNumber,
			ifsc: controls.ifsc,
		};
		setLoding(true);
		getPennyDrop(params).then((resp) => {
			setLoding(false);
			if (resp.success) {
				setRefresh(!refresh);
				if(resp?.data?.verificationStatus !== "SUCCESS"){
					setAlert({ type: 'error', msg: resp?.data?.description });
				}else{
					setIsVerify(true);
					setAlert({ type: 'success', msg:resp?.data?.description });
					setControls({...controls,beneName:resp?.data?.customerName})
					setBeneName(resp?.data?.customerName);
				}
				
			} else {
		setBeneName("");
		setIsVerify(false);
				if (resp?.errorCodeList.length > 0) {
					setAlert({ type: 'error', msg: resp?.errorCodeList[0] });
				}else{
					setAlert({ type: 'error', msg: resp?.msg });
				}
			}
		});
}
	

	return (
		<ModalWraper width="600px">
			<div className="modal pay-modal" ref={boxRef}>
				<div className="modal-header">
					<div className="modal-title">Add Beneficiary</div>
					<div className="modal-close" onClick={onCloseModal}>
						<IconClose />
					</div>
				</div>
				<div className="modal-body">
					<div className="pay-modal-form">
						{!isEmpty(pageMsg) && (
							<AlertWrapper className={pageMsg?.type}>
								<span className="close" onClick={() => setPageMsg({})}>
									×
								</span>
								{pageMsg?.text}
							</AlertWrapper>
						)}
						{!isEmpty(beneName) && (
							<AlertWrapper className={"success"}>
								<span className="close" onClick={() => setBeneName("")}>
									×
								</span>
								Account Holder: {beneName}
							</AlertWrapper>
						)}
						<div className="row">
							<div className="col-6">
								<div className="form-field">
									<input type="text" name="beneName" placeholder="Beneficiary Name"
									disabled={isVerifyOtp} value={controls?.beneName} onChange={(e) => changeHandler(e)} />
								</div>
							</div>
							<div className="col-6">
								<div className="form-field">
									<input type="text" name="beneMobileNumber" placeholder="Beneficiary Mobile"
									disabled={isVerifyOtp} value={controls?.beneMobileNumber} onChange={(e) => changeHandler(e)} />
								</div>
							</div>
							
						</div>
						<div className="row">
						<div className="col-6">
								<div className="form-field">
									<input type="text"
									disabled={isVerifyOtp} name="accountNumber" placeholder="Account Number" inputMode="numeric" value={controls?.accountNumber} onChange={(e) => changeHandler(e)} />
								</div>
							</div>
						
							<div className="col-6" style={{ width: '50%' }}>
								<div className="form-field" style={{ position: 'relative' }}>
									<input type="text"
									disabled={isVerifyOtp} name="amount"  placeholder="Search Bank..." value={searchKey} onChange={handleFilter} onFocus={(e) => setDropdown(true)} />
									{dropDown && (
										<div className="radio-group bankList">
											{filterBankList &&
												filterBankList.map((val, index) => {
													return (
														<label style={{ display: 'block' }} key={index} className={controls.bankId == val?.bankId ? 'radio active' : 'radio'}>
															<input type="radio" name="bankId" value={val?.bankId} onChange={(e) => selectBankWithMifsc(e,val)} />
															<span className="icon-with-name">{val?.name}</span>
														</label>
													);
												})}
										</div>
									)}
								</div>
							</div>
							
							
						</div>
						<div className="row">
							<div className="col-6">
								<div className="form-field">
									<input type="text" name="ifsc" placeholder="Ifsc code"
									disabled={isVerifyOtp} value={controls?.ifsc} onChange={(e) => changeHandler(e)} />
								</div>
							</div>
							
							
							
						</div>
						{isVerifyOtp &&	<div className="row">
							<div className="col-6">
								<div className="form-field">
									<input
										type="text"
										name="otp"
										placeholder="Enter Otp"
										inputMode="numeric"
										value={otp}
										
										onChange={(e) => (!numberReg.test(e.target.value) && e.target.value ? '' : setOtp(e.target.value))}
									/>
								</div>
							</div>
						
						</div>}
					</div>
				</div>
				<div className="modal-footer center">
						
					{isVerifyOtp ? (
						<button className="button-solid" onClick={onVefify} disabled={otp.length !== 6}>
							SUBMIT
						</button>
					) : (
						<>
						{!isVerify && <button className="button-solid" onClick={verifyAccount} disabled={!controls?.ifsc || !controls?.accountNumber || !controls?.bankId} style={{marginRight:"10px",}}>
							Verify Account
						</button>}
						<button className="button-solid" onClick={onSubmit} disabled={!controls?.ifsc || !controls?.accountNumber || !controls?.bankId || !controls?.beneName || !controls?.beneMobileNumber}>
							Add Beneficiary
						</button>
						</>
					)}
				</div>
				{loding && <Loader />}
			</div>
		</ModalWraper>
	);
}
